/** App API del módulo Promociones — hooks, use cases, presentation, engine.
 * Importar desde acá para evitar require cycles cuando se necesita solo app. */

export {
  evaluateCart,
  isLineEligibleForAutoPromo,
  isPromotionScheduleActive,
  promotionAppliesToBranch,
  promotionAppliesToChannel,
  promotionMatchesLine,
  buildTargetsByPromotionId,
  sortPromotionsForEvaluation,
  estimatePromotionBenefit,
  checkPromotionConditions,
} from './application/promotionEngine';

export {
  detectPromotionConflicts,
  type PromotionConflict,
} from './application/promotionConflicts';

export {
  PROMOTION_KIND_LABELS,
  PROMOTION_SCOPE_LABELS,
  PROMOTION_APPLY_MODE_LABELS,
  PROMOTION_TARGET_TYPE_LABELS,
  PROMOTION_APPLIES_TO_HELPER,
  getPromotionScopeHelperText,
  formatPromotionBenefit,
  formatPromotionSchedule,
  formatPromotionListDetail,
  formatPromotionValidity,
  promotionStatusLabel,
  promotionStatusTone,
  type PromotionStatusTone,
} from './application/promotionPresentation';

export {
  buildEvaluatedLineMap,
  formatPosLinePriceBlock,
  formatPosLinePromoHint,
  formatPosLinePromoAccessibilityLabel,
  formatPosLineDiscountBadge,
  type PosLineDiscountBadge,
  formatPromoMoney,
  summarizeCheckoutDiscounts,
  summarizeCheckoutLines,
  type CheckoutDiscountSummaryRow,
  type CheckoutLineSummaryRow,
  type PosLinePriceBlock,
} from './application/posCartPromotionPresentation';

export {
  usePromotionsListScreen,
  type PromotionListFilter,
  type PromotionSortKey,
  type PromotionSortDir,
  type PromotionViewMode,
} from './application/usePromotionsListScreen';
export {
  usePromotionEditScreen,
  type PromotionEditTargetDraft,
} from './application/usePromotionEditScreen';
export { usePromotionHistory } from './application/usePromotionHistory';
export { usePromotionsReloadBus } from './application/promotionsReloadBus';
